import React from 'react';
import eyeblue from '../../../images/eyeblue.svg';
import styles from './RequestCards.module.css';
import { formatShortDate } from '../../../utils/date';

// Color del estado (tokens --color-status-* en tokens.css).
const STATUS_CLASS = {
  'Recibida': styles.statusReceived,
  'En proceso': styles.statusInProgress,
  'Listo para retiro': styles.statusReady,
  'Entregado': styles.statusDelivered,
  'Finalizado': styles.statusFinished,
  'Rechazado': styles.statusRejected,
};

// Solicitudes como tarjetas (móvil y tablet portrait): mismo contenido que una fila de la tabla de
// RequestList / StoreroomRequestList. Las acciones las pone cada lista con renderAction.
const RequestCards = ({ pedidos, showUser = false, onShowItems, renderAction }) => {
  if (!pedidos || pedidos.length === 0) {
    return <p className={styles.empty}>No hay solicitudes.</p>;
  }

  return (
    <ul className={styles.list}>
      {pedidos.map((pedido) => (
        <li key={pedido.id} className={styles.card}>
          <div className={styles.header}>
            <strong className={styles.id}>#{pedido.id}</strong>
            <div className={`${styles.status} ${STATUS_CLASS[pedido.estado] || ''}`}>{pedido.estado}</div>
          </div>
          {showUser && <div className={styles.user}>{pedido.usuario?.nombre}</div>}
          <dl className={styles.details}>
            <div className={styles.row}>
              <dt>Ítems</dt>
              <dd className={styles.items}>
                {pedido.items}
                <button
                  type="button"
                  className={styles.itemsButton}
                  onClick={() => onShowItems(pedido)}
                  aria-label={`Ver ítems de la solicitud ${pedido.id}`}
                >
                  <img src={eyeblue} alt="" />
                </button>
              </dd>
            </div>
            <div className={styles.row}>
              <dt>Creación</dt>
              <dd>{formatShortDate(pedido.pedido_creation_date)}</dd>
            </div>
            <div className={styles.row}>
              <dt>Retiro</dt>
              <dd>{formatShortDate(pedido.fecha_creacion)}</dd>
            </div>
            <div className={styles.row}>
              <dt>Devolución</dt>
              <dd>{formatShortDate(pedido.fecha_resolucion)}</dd>
            </div>
          </dl>
          <div className={styles.actions}>{renderAction(pedido)}</div>
        </li>
      ))}
    </ul>
  );
};

export default RequestCards;
